


















































import Vue from 'vue';
import Component from 'vue-class-component';
import {Model, Prop, Watch} from 'vue-property-decorator';
import Grid from '../../ae-grid';
import Icon from '../../ae-icon';
import DSelect from '../../d-select';

Vue.use(Icon);
Vue.use(Grid);
Vue.use(DSelect);
@Component({
  name: 'DYearPicker'
})
export default class DYearPicker extends Vue {
  @Model('change')
  private value!: any;
  @Prop({type: Boolean, default: false}) private clearable!: boolean;
  @Prop({
    type: Function,
    default: () => false
  }) private disabledDate!: (year: string) => boolean;
  @Prop({type: Boolean, default: false}) private multiple!: boolean;
  private val: number[] | number = this.multiple ? [] : null;
  @Prop({default: '请选择年份', type: String}) private placeholder!: string;
  private date = new Date().getFullYear();

  get startYear(): number {
    return Math.floor(this.date / 10) * 10;
  }

  @Watch('val', {immediate: true})
  public onSelectedChange(val: string[] | string) {
    this.$emit('change', val);
  }

  private shouldDisabled(year: string) {
    return this.disabledDate(year);
  }

  private switchYearToLeft() {
    this.date -= 10;
  }

  private switchYearToRight() {
    this.date += 10;
  }

  public toggleValue(value: number, event: MouseEvent) {
    const select = this.$refs.select as any;
    if (this.multiple) {
      const val = this.val as number[];
      if (val.includes(value)) {
        val.splice(val.indexOf(value), 1);
      } else {
        val.push(value);
      }
    } else {
      if (value !== this.val) {
        this.val = value;
      }
      select.close();
    }
  }

}
